var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup35783(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.236,
    height: 54.519,
    viewBox: "0 0 55.236 54.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35783"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42198",
    d: "m218.619 195.031 1.518 1.22c.867-.538.983-.53 1.782.1 2.041 1.624 4.1 3.221 6.119 4.88a3.824 3.824 0 0 1-.6 6.443 3.594 3.594 0 0 1-4.017-.316c-2.239-1.713-4.425-3.5-6.632-5.251-.508-.4-.45-.879-.128-1.4l-1.569-1.259a6.127 6.127 0 0 0-.13.836q-.011 6.072 0 12.145a3.183 3.183 0 0 1-1.4 2.806 3.684 3.684 0 0 1-2.2.545h-33.56a3.21 3.21 0 0 1-3.513-3.5V164.8a3.211 3.211 0 0 1 3.54-3.527q13.039 0 26.079-.007a1.855 1.855 0 0 1 1.344.52q4.573 4.208 9.177 8.387a1.5 1.5 0 0 1 .532 1.2q-.022 4.519.006 9.037a1.152 1.152 0 0 0 .323.776 11.82 11.82 0 0 1 3.437 13.5c-.035.108-.066.214-.108.345zM203.508 163H177.98a4.437 4.437 0 0 0-.745.042 1.389 1.389 0 0 0-1.2 1.278 5.967 5.967 0 0 0-.013.633V212.2c0 1.357.5 1.852 1.892 1.852h33.443c1.4 0 1.876-.468 1.876-1.854v-11.347a11.652 11.652 0 0 1-8.292 1.03 11.872 11.872 0 0 1-6.861-18.388 11.487 11.487 0 0 1 5.69-4.294 11.981 11.981 0 0 1 9.423.611v-7.866c-.191-.01-.34-.024-.49-.025h-7.2a1.8 1.8 0 0 1-2-1.941c-.007-1.189 0-2.378 0-3.567zm14.347 27.3a10.116 10.116 0 1 0-10.08 10.194 10.082 10.082 0 0 0 10.08-10.194z",
    style: {
      fill: "#f26c6d"
    },
    transform: "translate(-174.292 -161.262)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42199",
    d: "M192.893 172.638H178.5a3.683 3.683 0 0 1-.574-.015.851.851 0 0 1-.106-1.666 2.359 2.359 0 0 1 .626-.045h28.958a2.31 2.31 0 0 1 .627.046.8.8 0 0 1 .632.851.808.808 0 0 1-.746.814 3.682 3.682 0 0 1-.574.015z",
    transform: "translate(-172.874 -156.534)",
    style: {
      fill: "#f26c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42200",
    d: "M192.9 194.133h-14.39a3.857 3.857 0 0 1-.63-.025.84.84 0 0 1-.058-1.64 2.764 2.764 0 0 1 .629-.046h28.95a2.938 2.938 0 0 1 .574.034.841.841 0 0 1-.054 1.663 4.961 4.961 0 0 1-.632.016z",
    transform: "translate(-172.874 -145.996)",
    style: {
      fill: "#f26c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42201",
    d: "M187.291 187.054h8.856c.173 0 .393-.06.508.024a1.888 1.888 0 0 1 .7.715.7.7 0 0 1-.513.9 2.312 2.312 0 0 1-.733.086q-8.826.007-17.655 0a2.257 2.257 0 0 1-.732-.088.693.693 0 0 1-.5-.9 1.9 1.9 0 0 1 .7-.711c.113-.083.335-.024.507-.024z",
    transform: "translate(-172.877 -148.635)",
    style: {
      fill: "#f26c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42202",
    d: "M185.643 176.3h7.366c.627 0 1.016.338 1.015.848s-.4.845-1.015.869h-14.503c-.153 0-.308.009-.46-.006a.867.867 0 0 1-.863-.893.831.831 0 0 1 .919-.815c1.727-.01 3.454-.006 5.181-.006z",
    transform: "translate(-172.876 -153.894)",
    style: {
      fill: "#f26c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42203",
    d: "M185.608 183.386h-7.2c-.171 0-.395.058-.507-.027a1.889 1.889 0 0 1-.687-.727.7.7 0 0 1 .527-.888 2.149 2.149 0 0 1 .678-.08q7.168-.007 14.332 0a2.522 2.522 0 0 1 .572.037.8.8 0 0 1 .684.867.787.787 0 0 1-.808.809c-.554.022-1.112.01-1.669.012z",
    transform: "translate(-172.876 -151.268)",
    style: {
      fill: "#f26c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42204",
    d: "M185.573 167.271h-7.136c-.229 0-.527.046-.67-.075-.25-.212-.562-.541-.554-.812s.34-.58.6-.778c.152-.115.444-.058.673-.058h14.156a5.277 5.277 0 0 1 .575.019.845.845 0 0 1 .006 1.684c-.38.039-.766.022-1.15.024l-6.5-.004z",
    transform: "translate(-172.861 -159.17)",
    style: {
      fill: "#f26c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42205",
    d: "M191.083 182.9a8.413 8.413 0 0 1 6.393-7.59c.656-.159 1.106.039 1.249.553s-.162.933-.8 1.106a6.593 6.593 0 0 0-4.859 4.661 11.114 11.114 0 0 0-.271 1.463.861.861 0 0 1-.919.821.887.887 0 0 1-.793-1.014z",
    transform: "translate(-166.066 -154.405)",
    style: {
      fill: "#f26c6d"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35783);
export default __webpack_public_path__ + "static/media/Group-35783.43ce77dcfbc3341695c03beae18c67ff.svg";
export { ForwardRef as ReactComponent };